export default __webpack_public_path__ + "static/real-estate-adc1941ece1955a7bbc21e433724a102.png";